import React from 'react';
import { Helmet } from 'react-helmet-async';

const CircleMetaTags = ({ circle }) => {
  if (!circle) return null;

  const baseUrl = process.env.REACT_APP_BASE_URL || window.location.origin;
  const shareUrl = `${baseUrl}/circle/${circle.id}`;
  const defaultImage = `${baseUrl}/circledin-share.jpg`;

  // Format all content with null checks
  const content = {
    title: circle.name ? 
      `Join ${circle.name} - ${circle.carrier_name || ''} Circle | Circledin` : 
      'Join our Circle | Circledin',
    description: `Save money on your ${circle.carrier_name || ''} plan! Join our circle for $${circle.monthly_payment_per_line || '0'}/month. ${circle.available_slots || '0'} spots left.`,
    image: circle.carrier_name ? 
      `${baseUrl}/images/carriers/${circle.carrier_name.toLowerCase()}.jpg` : 
      defaultImage,
    features: circle.features?.filter(f => f.is_primary)
      .map(f => f.short_description)
      .join(', ') || ''
  };

  // Add features to description if available
  if (content.features) {
    content.description += ` Features: ${content.features}`;
  }

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{content.title}</title>
      <meta name="description" content={content.description} />
      <link rel="canonical" href={shareUrl} />

      {/* OpenGraph Tags */}
      <meta property="og:site_name" content="Circledin" />
      <meta property="og:title" content={content.title} />
      <meta property="og:description" content={content.description} />
      <meta property="og:image" content={content.image} />
      <meta property="og:url" content={shareUrl} />
      <meta property="og:type" content="product.group" />
      
      {/* Product Specific OpenGraph Tags */}
      {circle.monthly_payment_per_line && (
        <>
          <meta property="og:price:amount" content={circle.monthly_payment_per_line} />
          <meta property="og:price:currency" content="USD" />
        </>
      )}
      <meta property="og:availability" content={circle.available_slots > 0 ? 'instock' : 'outofstock'} />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@circledin" />
      <meta name="twitter:creator" content="@circledin" />
      <meta name="twitter:title" content={content.title} />
      <meta name="twitter:description" content={content.description} />
      <meta name="twitter:image" content={content.image} />
      
      {/* Additional SEO Meta Tags */}
      <meta name="keywords" content={`${circle.carrier_name || ''} plan, mobile plan, phone plan, save money, group plan, family plan, ${circle.plan_name || ''}`} />
      <meta name="author" content="Circledin" />
      <meta name="robots" content="index, follow" />
      
      {/* Additional Meta Tags for Rich Snippets */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Product",
          "name": circle.name,
          "description": content.description,
          "image": content.image,
          "offers": {
            "@type": "Offer",
            "price": circle.monthly_payment_per_line,
            "priceCurrency": "USD",
            "availability": circle.available_slots > 0 ? "InStock" : "OutOfStock"
          },
          "brand": {
            "@type": "Brand",
            "name": circle.carrier_name
          }
        })}
      </script>
    </Helmet>
  );
};

export default CircleMetaTags;